import(/* webpackMode: "eager" */ "/codegient-poc/app/global-error.tsx")